/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useImperativeHandle, useRef, useState } from "react";
import { configureMainSkillFormData } from "./config/ConfigureSkillCategory.data";
import FormCreator from "../../../../components/FinalForms/FormCreator";
import Buttons from "../../../../components/ui/button/Buttons";
import { useAddJobMainSkillMutation, useLazyGetAllMainSkillByCategoriesIdQuery } from "../../../../app/services/skillCategoriesAPI";
import { setDropDownOptionField } from "../../../../utils/FormFields/FieldsSetting/SetFieldSetting";
import { onResetForm } from "../../../../utils/FormFields/ResetForm/handleResetForm";
import ToastService from "../../../../services/toastService/ToastService";

const ConfigureMainSkill = ({ mainSkillRef, positionAppliedId, onClose ,refreshGrid}) => {
    const ref = useRef();
    const [formData, setFormData] = useState(configureMainSkillFormData);
    const [skillCategoryId, setSubSkillCategoryId] = useState(0);
    const [shouldRerenderFormCreator, setShouldRerenderFormCreator] = useState(false);
    const [getAllMainSkillByCategoriesId, { isFetching: isGetAllMainSkillByCategoriesIdFetching, isSuccess: isGetAllMainSkillByCategoriesIdSuccess, data: isGetAllMainSkillByCategoriesIdData, }] = useLazyGetAllMainSkillByCategoriesIdQuery();
    const [addJobMainSkill, { isLoading: isAddJobMainSkillLoading, isSuccess: isAddJobMainSkillSuccess, data: isAddJobMainSkillData }] = useAddJobMainSkillMutation();

    useEffect(() => {
        if (!isGetAllMainSkillByCategoriesIdFetching && isGetAllMainSkillByCategoriesIdSuccess && isGetAllMainSkillByCategoriesIdData) {
            setDropDownOptionField(isGetAllMainSkillByCategoriesIdData, "mainSkillId", "mainSkillName", formData, "mainSkillId");
            setShouldRerenderFormCreator((prevState) => !prevState);
        }
    }, [isGetAllMainSkillByCategoriesIdFetching, isGetAllMainSkillByCategoriesIdSuccess, isGetAllMainSkillByCategoriesIdData, formData]);


    const handleAddMainSkillClick = () => {

        let mainSkillForm = ref.current.getFormData();

        if (mainSkillForm) {
            const request = {
                skillCategoriesId: skillCategoryId,
                positionAppliedId: positionAppliedId,
                mainSkillId: mainSkillForm.mainSkillId.join(','),
            }
            addJobMainSkill(request);
        }
    }
    const getMainSkillCategoryId = (id) => {

        getAllMainSkillByCategoriesId(id)
        setSubSkillCategoryId(id)
    }

    useImperativeHandle(mainSkillRef, () => ({
        getMainSkillCategoryId
    }));

    useEffect(() => {
        if (isAddJobMainSkillSuccess && isAddJobMainSkillData) {
            
            if (isAddJobMainSkillData.errorMessage.includes("exists")) {
                ToastService.warning(isAddJobMainSkillData.errorMessage);
                return;
              }
            onClose();
            onResetForm(configureMainSkillFormData, setFormData, null)
            refreshGrid();
            ToastService.success(isAddJobMainSkillData.errorMessage);
        }
    }, [isAddJobMainSkillSuccess && isAddJobMainSkillData])

    return (<div className="mt-3">
        <form>
            <div className="row">
                <FormCreator
                    config={formData}
                    ref={ref}
                    {...formData}
                    key={shouldRerenderFormCreator}
                />
            </div>
        </form>
        <div className="row mt-3">
            <div className="col-12">
                <div className="form-btn d-flex justify-content-end">
                    <Buttons
                        buttonTypeClassName="btn dark-btn"
                        onClick={onClose}
                        buttonText="Cancel"
                    />
                    <Buttons
                        buttonTypeClassName="btn theme-btn ml-5"
                        onClick={handleAddMainSkillClick}
                        buttonText="Add"
                        isLoading={isAddJobMainSkillLoading}

                    />
                </div>
            </div>
        </div>
    </div>)
}
export default ConfigureMainSkill;